import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import MoonFilledSvg from "@ant-design/icons-svg/es/asn/MoonFilled";
import AntdIcon from "../components/AntdIcon";
var MoonFilled = function MoonFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: MoonFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  MoonFilled.displayName = 'MoonFilled';
}
export default /*#__PURE__*/React.forwardRef(MoonFilled);